import React from 'react'
import './Main.css'
import Resume from './../../pages/Resume/Resume'
import Portfolio from './../../pages/Portfolio/Portfolio'
import { useLocation } from 'react-router-dom'
import Contact from './../../pages/Contact/Contact'
import About from '../../pages/About/About'
import Error from "./../../pages/Error/Error";

const Main = () => {
  const location = useLocation()
  const pathName = location.pathname
  return (
    <div className='main-content br2'>
      {pathName === '/' ? (
        <About />
      ) : pathName === '/resume' ? (
        <Resume />
      ) : pathName === '/portfolio' ? (
        <Portfolio />
      ) : pathName === '/contact' ? (
        <Contact />
      ) : (
        <Error />
      )}
    </div>
  )
}

export default Main
